// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expression-builder {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.expression-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}
.expression-toggle input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.expression-toggle label {
  margin-left: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9em;
  color: #495057;
}

.expression-form {
  margin-top: 0.75rem;
}

.function-search {
  margin-bottom: 0.5rem;
}
.function-search input {
  font-size: 0.85em;
}

.function-select {
  margin-bottom: 0.75rem;
}
.function-select label {
  display: block;
  font-weight: 500;
  font-size: 0.85em;
  margin-bottom: 0.25rem;
  color: #495057;
}
.function-select select {
  font-size: 0.9em;
}
.function-select optgroup {
  font-weight: 600;
  color: #17a2b8;
}

.function-description {
  font-size: 0.8em;
  color: #6c757d;
  font-style: italic;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  background-color: #e9ecef;
  border-radius: 3px;
}
.function-description i {
  color: #17a2b8;
  margin-right: 0.25rem;
}

.parameter-form .param-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}
.parameter-form .param-row .param-label {
  min-width: 110px;
  max-width: 110px;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.85em;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.parameter-form .param-row .param-label .required-indicator {
  color: #dc3545;
  margin-left: 2px;
}
.parameter-form .param-row .input-group {
  flex: 1;
}
.parameter-form .param-row input, .parameter-form .param-row select {
  flex: 1;
  font-size: 0.85em;
}
.parameter-form .param-row .insert-path-btn {
  font-size: 0.75em;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.parameter-form .param-row .insert-path-btn i {
  margin-right: 2px;
}

.expression-preview {
  margin-top: 0.75rem;
  padding: 0.5rem 0.75rem;
  background-color: #e9ecef;
  border-radius: 4px;
  border-left: 3px solid #17a2b8;
}
.expression-preview label {
  display: block;
  font-size: 0.75em;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.expression-preview code {
  display: block;
  font-size: 0.85em;
  word-break: break-all;
  color: #495057;
  background: transparent;
  padding: 0;
}

.validation-message {
  margin-top: 0.5rem;
  font-size: 0.8em;
}
.validation-message i {
  margin-right: 0.25rem;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.input-group-append .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/add-mapping-dialog/expression-builder/expression-builder.component.scss","webpack://./../../../Git%20space/admin/standalone-hl7-viewer/src/app/hl7viewer/add-mapping-dialog/expression-builder/expression-builder.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;ACCF;ADCE;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACCJ;ADEE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ACAJ;;ADIA;EACE,mBAAA;ACDF;;ADIA;EACE,qBAAA;ACDF;ADGE;EACE,iBAAA;ACDJ;;ADKA;EACE,sBAAA;ACFF;ADIE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ACFJ;ADKE;EACE,gBAAA;ACHJ;ADME;EACE,gBAAA;EACA,cAAA;ACJJ;;ADQA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;ACLF;ADOE;EACE,cAAA;EACA,qBAAA;ACLJ;;ADUE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;ACPJ;ADSI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACPN;ADSM;EACE,cAAA;EACA,gBAAA;ACPR;ADWI;EACE,OAAA;ACTN;ADYI;EACE,OAAA;EACA,iBAAA;ACVN;ADaI;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;ACXN;ADaM;EACE,iBAAA;ACXR;;ADiBA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;ACdF;ADgBE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;ACdJ;ADiBE;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;ACfJ;;ADmBA;EACE,kBAAA;EACA,gBAAA;AChBF;ADkBE;EACE,qBAAA;AChBJ;;ADqBA;EACE,kCAAA;EACA,uBAAA;EACA,mBAAA;AClBF;;ADuBE;EACE,yBAAA;EACA,4BAAA;ACpBJ","sourcesContent":[".expression-builder {\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.expression-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e9ecef;\n\n  input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n\n  label {\n    margin-left: 0.5rem;\n    margin-bottom: 0;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 0.9em;\n    color: #495057;\n  }\n}\n\n.expression-form {\n  margin-top: 0.75rem;\n}\n\n.function-search {\n  margin-bottom: 0.5rem;\n\n  input {\n    font-size: 0.85em;\n  }\n}\n\n.function-select {\n  margin-bottom: 0.75rem;\n\n  label {\n    display: block;\n    font-weight: 500;\n    font-size: 0.85em;\n    margin-bottom: 0.25rem;\n    color: #495057;\n  }\n\n  select {\n    font-size: 0.9em;\n  }\n\n  optgroup {\n    font-weight: 600;\n    color: #17a2b8;\n  }\n}\n\n.function-description {\n  font-size: 0.8em;\n  color: #6c757d;\n  font-style: italic;\n  margin-bottom: 0.75rem;\n  padding: 0.5rem;\n  background-color: #e9ecef;\n  border-radius: 3px;\n\n  i {\n    color: #17a2b8;\n    margin-right: 0.25rem;\n  }\n}\n\n.parameter-form {\n  .param-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n    gap: 0.5rem;\n\n    .param-label {\n      min-width: 110px;\n      max-width: 110px;\n      margin-bottom: 0;\n      font-weight: 500;\n      font-size: 0.85em;\n      color: #495057;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      .required-indicator {\n        color: #dc3545;\n        margin-left: 2px;\n      }\n    }\n\n    .input-group {\n      flex: 1;\n    }\n\n    input, select {\n      flex: 1;\n      font-size: 0.85em;\n    }\n\n    .insert-path-btn {\n      font-size: 0.75em;\n      padding: 0.25rem 0.5rem;\n      white-space: nowrap;\n\n      i {\n        margin-right: 2px;\n      }\n    }\n  }\n}\n\n.expression-preview {\n  margin-top: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  border-left: 3px solid #17a2b8;\n\n  label {\n    display: block;\n    font-size: 0.75em;\n    font-weight: 600;\n    color: #6c757d;\n    margin-bottom: 0.25rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  code {\n    display: block;\n    font-size: 0.85em;\n    word-break: break-all;\n    color: #495057;\n    background: transparent;\n    padding: 0;\n  }\n}\n\n.validation-message {\n  margin-top: 0.5rem;\n  font-size: 0.8em;\n\n  i {\n    margin-right: 0.25rem;\n  }\n}\n\n// Form control sizing\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n\n// Input group adjustments\n.input-group-append {\n  .btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n",".expression-builder {\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.expression-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e9ecef;\n}\n.expression-toggle input[type=checkbox] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n.expression-toggle label {\n  margin-left: 0.5rem;\n  margin-bottom: 0;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9em;\n  color: #495057;\n}\n\n.expression-form {\n  margin-top: 0.75rem;\n}\n\n.function-search {\n  margin-bottom: 0.5rem;\n}\n.function-search input {\n  font-size: 0.85em;\n}\n\n.function-select {\n  margin-bottom: 0.75rem;\n}\n.function-select label {\n  display: block;\n  font-weight: 500;\n  font-size: 0.85em;\n  margin-bottom: 0.25rem;\n  color: #495057;\n}\n.function-select select {\n  font-size: 0.9em;\n}\n.function-select optgroup {\n  font-weight: 600;\n  color: #17a2b8;\n}\n\n.function-description {\n  font-size: 0.8em;\n  color: #6c757d;\n  font-style: italic;\n  margin-bottom: 0.75rem;\n  padding: 0.5rem;\n  background-color: #e9ecef;\n  border-radius: 3px;\n}\n.function-description i {\n  color: #17a2b8;\n  margin-right: 0.25rem;\n}\n\n.parameter-form .param-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  gap: 0.5rem;\n}\n.parameter-form .param-row .param-label {\n  min-width: 110px;\n  max-width: 110px;\n  margin-bottom: 0;\n  font-weight: 500;\n  font-size: 0.85em;\n  color: #495057;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.parameter-form .param-row .param-label .required-indicator {\n  color: #dc3545;\n  margin-left: 2px;\n}\n.parameter-form .param-row .input-group {\n  flex: 1;\n}\n.parameter-form .param-row input, .parameter-form .param-row select {\n  flex: 1;\n  font-size: 0.85em;\n}\n.parameter-form .param-row .insert-path-btn {\n  font-size: 0.75em;\n  padding: 0.25rem 0.5rem;\n  white-space: nowrap;\n}\n.parameter-form .param-row .insert-path-btn i {\n  margin-right: 2px;\n}\n\n.expression-preview {\n  margin-top: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  border-left: 3px solid #17a2b8;\n}\n.expression-preview label {\n  display: block;\n  font-size: 0.75em;\n  font-weight: 600;\n  color: #6c757d;\n  margin-bottom: 0.25rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.expression-preview code {\n  display: block;\n  font-size: 0.85em;\n  word-break: break-all;\n  color: #495057;\n  background: transparent;\n  padding: 0;\n}\n\n.validation-message {\n  margin-top: 0.5rem;\n  font-size: 0.8em;\n}\n.validation-message i {\n  margin-right: 0.25rem;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n\n.input-group-append .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
